import PropTypes from "prop-types";
import React from "react";
import { FormGroup } from "react-bootstrap";
import Select from "react-select";
import { sortByDisplayNameAsc } from "util/sort-by-prop";

class OptionalParamsSelector extends React.PureComponent {
  static get propTypes() {
    return {
      active: PropTypes.arrayOf(PropTypes.string),
      onSelect: PropTypes.func.isRequired,
      schemas: PropTypes.arrayOf(PropTypes.object),
    };
  }

  static get defaultProps() {
    return {
      active: [],
      schemas: [],
    };
  }

  constructor() {
    super();

    this._onChange = this._onChange.bind(this);
  }

  _formatOption({ value: schema }) {
    const { display_name: displayName, description } = schema;

    return (
      <span>
        {displayName}
        {description && (
          <span className="font-smaller text-muted"> ({description})</span>
        )}
      </span>
    );
  }

  _onChange(option) {
    const { onSelect } = this.props;

    onSelect(option.value);
  }

  render() {
    const { active, schemas } = this.props;
    const options = schemas
      .filter((s) => !s.required)
      .filter((s) => !active.includes(s.name))
      .sort(sortByDisplayNameAsc)
      .map((s) => ({ label: s.display_name, value: s }));

    return (
      <FormGroup>
        <Select
          onChange={this._onChange}
          clearable={false}
          formatOptionLabel={this._formatOption}
          noOptionsMessage={() => "No more optional app parameters available."}
          options={options}
          styles={{ menu: (s) => ({ ...s, zIndex: 100 }) }}
          value={null}
        />
      </FormGroup>
    );
  }
}

export { OptionalParamsSelector };
